// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M3py","footer":"styles_footer__oB9qB","passCodeTooltip":"styles_passCodeTooltip__97Gul"};